import { createAsyncThunk } from '@reduxjs/toolkit';
import { FaqImportExportAPI } from '@/api';
import { formatApiError } from '@/utils';
import { IApiError } from '@/models/apiError.model';
import {
  IApplyFaqImportDTO,
  IFaqExportDTO,
  IFaqImportResponse,
  IPreviewFaqImportDTO,
} from '@/models/faqImportExport.model';
import { SLICE_NAME } from './models';

export const previewFaqImport = createAsyncThunk<
  IFaqImportResponse,
  IPreviewFaqImportDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/previewFaqImport`,
  async (data) => {
    const response = await FaqImportExportAPI.importFaqs({ ...data, dryRun: true });
    return response.data;
  },
  { serializeError: formatApiError },
);

export const applyFaqImport = createAsyncThunk<
  IFaqImportResponse,
  IApplyFaqImportDTO,
  { serializedErrorType: IApiError }
>(
  `${SLICE_NAME}/applyFaqImport`,
  async (data) => {
    const response = await FaqImportExportAPI.importFaqs({ ...data, dryRun: false });
    return response.data;
  },
  { serializeError: formatApiError },
);

export const exportFaqs = createAsyncThunk<Blob, IFaqExportDTO, { serializedErrorType: IApiError }>(
  `${SLICE_NAME}/exportFaqs`,
  async (params) => {
    const response = await FaqImportExportAPI.exportFaqs(params);
    return response.data;
  },
  { serializeError: formatApiError },
);
